let readySizePDP = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

readySizePDP(() => {
  const firstVariantWrapper = document.querySelector('.variant-wrapper.js'),
    dropdownContent = document.querySelector('.dropdown-content');
  firstVariantWrapper.style.display = 'none';
  firstVariantWrapper.closest('.parent-selector') && (firstVariantWrapper.closest('.parent-selector').style.display = 'none');

  if (dropdownContent) {
    // Call the functions to select the default values
    selectDefaultSize();
    resetBundleSelection();

    function updateRadioButtonSelection(value) {
      const valueSelectedSize = document.querySelector('.value-selected-size');
      if (valueSelectedSize) {
        valueSelectedSize.textContent = value;
      }
      
      // Identify if the value is a size or bundle
      if (value === "Standard" || value === "Thick") {
        // Select the corresponding size radio button
        const sizeRadioButton = document.querySelector(`input[name="Height"][value="${value}"]`);
        if (sizeRadioButton) {
          sizeRadioButton.checked = true;
          const changeEvent = new Event('change', { bubbles: true });
          sizeRadioButton.dispatchEvent(changeEvent);
        }
      } else {
        // Select the corresponding bundle radio button
        const bundleRadioButton = document.querySelector(`input[name="Bundle"][value="${value}"]`);
        if (bundleRadioButton) {
          bundleRadioButton.checked = true;
          const changeEvent = new Event('change', { bubbles: true });
          bundleRadioButton.dispatchEvent(changeEvent);
        }
      }
    }

    // Function to auto select the 1-Pack radio button in the bundle
    function resetBundleSelection() {
      const onePackRadioButton = document.querySelector('.variant-wrapper.js input[type="radio"]');
      if (onePackRadioButton) {
        onePackRadioButton.checked = true;
        const changeEvent = new Event('change', { bubbles: true });
        onePackRadioButton.dispatchEvent(changeEvent);
      }
    }

    // Function to select the Queen size
    function selectDefaultSize() {
      const queenRadioButton = document.querySelector('.variant-option input[type="radio"][value="Standard"]');
      if (queenRadioButton) {
        const selectedDiv = queenRadioButton.closest('.variant-option');
        if (selectedDiv) {
          const activeVariantOption = dropdownContent.querySelector('.variant-option.active');
          if (activeVariantOption) {
            activeVariantOption.classList.remove('active');
          }

          const selectedValue = selectedDiv.querySelector('input[type="radio"]').value;
          updateRadioButtonSelection(selectedValue);

          // Add "active" class to the newly selected variant-option
          selectedDiv.classList.add('active');
        }
      }
    }

    dropdownContent.addEventListener('click', (event) => {
      const selectedDiv = event.target.closest('.variant-option');
      if (selectedDiv) {
        // Remove "active" class from any previously selected variant-option
        const activeVariantOption = dropdownContent.querySelector('.variant-option.active');
        if (activeVariantOption) {
          activeVariantOption.classList.remove('active');
        }

        const selectedValue = selectedDiv.querySelector('input[type="radio"]').value;
        updateRadioButtonSelection(selectedValue);
        
        // Add "active" class to the newly selected variant-option
        selectedDiv.classList.add('active');

        dropdownContent.style.display = 'none';
      }
    });
  }
});